import { render, staticRenderFns } from "./FaqSubCategory.vue?vue&type=template&id=4c02ab31"
import script from "./FaqSubCategory.vue?vue&type=script&lang=js"
export * from "./FaqSubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports